export enum ComponentType {
    PowerGrid = "Power Grid",
    LVGenset = "LV Genset",
    Transformer = "Transformer",
    LinearLoad = "Linear Load",
    NonLinearDriveLoad = "Non Linear (Drive Loads)",
    MCC = "MCC (Motor Control Center)",
    CustomNonLinearLoad = "Custom Non-Linear Load",
    ActiveHarmonicFilter = "Active Harmonic Filter"
}